export var PageEvents;
(function (PageEvents) {
    PageEvents["B2CLOADED"] = "b2cloaded";
    PageEvents["FORM_SUBMITTED"] = "formSubmitted";
    PageEvents["GTMJS"] = "gtm.js";
    PageEvents["PAGE_NAVIGATION_EVENT"] = "PageNavigationEvent";
    PageEvents["PAGE_VIEW"] = "pageview";
})(PageEvents || (PageEvents = {}));
